import StorboltHeader from "components/partials/header";
import StorboltFooter from "components/partials/footer";
import StorboltSidebar from "components/partials/sidebar";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AccountCheckToast from "components/account-check-toast";
import BoostOnMetaDialog from "components/boost-on-meta-dialog";
import { useConfig } from "hooks/use-config";
import { useMenuHoverConfig } from "hooks/use-menu-hover";
import { cn } from "lib/utils";

/**
 * App shell: a fixed sidebar on large screens (a slide-in drawer on smaller ones), a sticky top bar,
 * and page content centred in a max-width column.
 */
export default function MainLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [config, setConfig] = useConfig();
  const [hoverConfig] = useMenuHoverConfig();
  const { pathname } = useLocation();
  const collapsed = config.collapsed && !hoverConfig.hovered;

  // The phone menu closes once a page has been chosen.
  useEffect(() => {
    setConfig((current) => (current.menuHidden ? current : { ...current, menuHidden: true }));
  }, [pathname, setConfig]);

  return (
    <div className="min-h-dvh bg-background">
      <AccountCheckToast />
      <StorboltSidebar />
      <div
        className={cn(
          "flex min-h-dvh flex-col transition-[padding] duration-300",
          collapsed ? "lg:ps-[72px]" : "lg:ps-[248px]",
        )}
      >
        <StorboltHeader />
        <main className="flex-1">
          <div className="mx-auto w-full max-w-[1400px] px-4 py-6 md:px-8 md:py-8 lg:px-10">
            {children}
          </div>
        </main>
        <StorboltFooter />
      </div>
      <BoostOnMetaDialog />
    </div>
  );
}
